/** Operations can arrive with decoded or JSON-encoded payloads. */
export function referenceWarnings(operation: Record<string, unknown>): string[] {
  const warnings = new Set<string>()
  for (const payload of [
    operation,
    operation.input,
    operation.result,
    operation.input_json,
    operation.result_json,
  ]) {
    try {
      const value = typeof payload === 'string' ? JSON.parse(payload) : payload
      if (value && typeof value === 'object' && Array.isArray(value.referenceWarnings)) {
        for (const warning of value.referenceWarnings)
          if (typeof warning === 'string') warnings.add(warning)
      }
    } catch {
      /* Malformed diagnostic data does not block history. */
    }
  }
  return [...warnings]
}
